export default {
    create_edit_package_edit_title: "Editar paquete",
    create_edit_package_create_title: "Crear paquete",
    create_edit_package_success_create: "El paquete ha sido creado",
    create_edit_package_success_edit: "El paquete ha sido editado",
    create_edit_package_name: "Nombre",
    create_edit_package_description: "Descripción",
    create_edit_package_brand: "Marca",
    create_edit_package_label: "Plataforma",
}